import { render, staticRenderFns } from "./LabelGenCreate.vue?vue&type=template&id=26059435"
import script from "./LabelGenCreate.vue?vue&type=script&lang=js"
export * from "./LabelGenCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports